import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { SelectNative } from '@/components/ui/select-native';
import { Switch } from '@/components/ui/switch';

const TIMER_OPTIONS = [10, 15, 20, 30, 45, 60];

export default function StepName({ formik, taxonomies, isEditing, editingId }) {
  const navigate = useNavigate();

  const handleNext = async e => {
    e.preventDefault();
    const errors = await formik.validateForm();
    formik.setTouched({ title: true, taxonomy_id: true, timer_seconds: true });
    if (errors.title || errors.taxonomy_id || errors.timer_seconds) return;

    const target = isEditing ? `/admin/desafio-ao-vivo/editar/questoes/${editingId}` : '/admin/desafio-ao-vivo/criar/questoes';
    navigate(target);
  };

  return (
    <div className="page page--wrap">
      <div className="page__col">
        <form
          className="form form--step-by-step"
          method="post"
          onSubmit={handleNext}
        >
          <div className="page__content mb-12 animate-fade-in">
            <div className="new-questions__header">
              <h2 className="new-questions__title">{isEditing ? 'Editar desafio ao vivo' : 'Novo desafio ao vivo'}</h2>
            </div>

            <div className="flex animate-fade-in flex-col gap-6">
              <Field>
                <FieldLabel htmlFor="title">* Título</FieldLabel>
                <Input
                  id="title"
                  name="title"
                  type="text"
                  placeholder="Ex: Revisão de Funções"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.title && formik.errors.title)}
                />
                {formik.touched.title && formik.errors.title && <FieldDescription className="text-danger">{formik.errors.title}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel htmlFor="taxonomy_id">* Tema</FieldLabel>
                <SelectNative
                  id="taxonomy_id"
                  name="taxonomy_id"
                  value={formik.values.taxonomy_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.taxonomy_id && formik.errors.taxonomy_id)}
                >
                  <option value="">Selecione um tema</option>
                  {taxonomies.map(t => (
                    <option
                      key={t.id}
                      value={t.id}
                    >
                      {t.name}
                    </option>
                  ))}
                </SelectNative>
                {formik.touched.taxonomy_id && formik.errors.taxonomy_id && <FieldDescription className="text-danger">{formik.errors.taxonomy_id}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel htmlFor="timer_seconds">* Tempo por questão</FieldLabel>
                <SelectNative
                  id="timer_seconds"
                  name="timer_seconds"
                  value={formik.values.timer_seconds}
                  onChange={e => formik.setFieldValue('timer_seconds', Number(e.target.value))}
                  onBlur={formik.handleBlur}
                >
                  {TIMER_OPTIONS.map(s => (
                    <option
                      key={s}
                      value={s}
                    >
                      {s} segundos
                    </option>
                  ))}
                </SelectNative>
                <FieldDescription>Quanto tempo cada participante terá para responder.</FieldDescription>
              </Field>

              <Field>
                <div className="flex items-center justify-between gap-4">
                  <div className="flex flex-col">
                    <FieldLabel htmlFor="is_public">Desafio público</FieldLabel>
                    <FieldDescription>{formik.values.is_public ? 'Outros professores podem ver e duplicar este desafio.' : 'Apenas você vê e edita este desafio.'}</FieldDescription>
                  </div>
                  <Switch
                    id="is_public"
                    checked={formik.values.is_public}
                    onCheckedChange={checked => formik.setFieldValue('is_public', checked)}
                  />
                </div>
              </Field>
            </div>
          </div>

          <div className="flex">
            <Button
              type="submit"
              variant="default"
              size="md"
              wide
            >
              Próximo
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
